import React from "react";
import { Typography } from "antd";

import styles from "./index.module.scss";

/**
 * The line each panel in the builder opens with — the panel's own name, or the
 * name of the section being edited.
 *
 * antd's Title at level 5, which is 16px at fontWeightStrong. One component
 * rather than three call sites, because all three need the same margin reset:
 * a Title carries block margins meant for flow layout (`titleMarginBottom` is
 * 0.5em, and there is a top margin for any Title that is not first), and the
 * panels are flex columns spaced by `gap`. Left alone, the two add up.
 */
export default function PanelTitle({ children }: React.PropsWithChildren) {
  return (
    <Typography.Title level={5} className={styles.title}>
      {children}
    </Typography.Title>
  );
}
